import React from "react"
import SearchImg from "../../../../../assets/avia/common/search.png"

const SearchInput = ({ value, onChange }) => {
  return (
    <div className="relative flex-1">
      <input
        type="text"
        className="w-full pl-3 pr-3 py-1.5 border-[0.3px] border-light-gray/30 rounded text-sm focus:border-light-gray focus:outline-none"
        value={value}
        onChange={onChange}
      />
      <img
        src={SearchImg}
        alt="search icon"
        className="absolute h-4 w-4 top-1/2 -translate-y-1/2 right-2 pointer-events-none opacity-50"
      />
    </div>
  )
}

export default SearchInput
